export const messages = {
  en: {
	navbar: {
		brand_name: "Csodaszarvas Íjászbarlang",
		about: "About",
		home: "Home",
		field: "Archery range",
		club: "Association",
		contact: "Contact",
		booking: "Booking",
		news: "News",
		products: "Products",
		bows: "Bows",
		arrows: "Arrows",
		quivers: "Quivers",
		targets: "Targets",
		protective: "Protective Equipment",
		other: "Others"
	},
	not_found:{
		title: "404",
		text: "This page not found."
	},
	main:{
		title: "Csodaszarvas Íjászbarlang",
		intro: "In the heart of Buda there is only one archery range (with 6 gunports) awaiting those who are interested in the challenges of archery. Here you have a chance to learn the basics from proficient archers. Advanced archers are welcome to practice shooting from as far as 18 meters with all types of bows without exception.",
		intro_second: "We are open for those who’d like to try out archery or just practice what they already know. Our shooting range can also be rented in order to give home to events as well (such as birthdays and team building). All this is available near to Móricz Zsigmond square within easy reach (a 3 minute walk).",
	},
	what_we_do:{
		title: "What do we do?",
		subtitle_first: "Renting the shooting range",
		text_first: "Our 18-21 metres long shooting range can be reserved by calling our number.",
		subtitle_sec: "Team building and birthdays",
		text_second: "You can rent the whole shooting range to give home to kinds of events, like team building or birthdays.",
		subtitle_third: "Making bows and arrows",
		text_third: "Our shop is taking orders for the making of traditional and hunter-reflex bows as well as arrows (with prior consultation).",
		subtitle_fourth: "Association life",
		text_fourth: "Our association awaits its new members, archers who are interested in competing and this sport.",
		subtitle_fifth: "Children’s Training",
		text_fifth: "We are awaiting the application of children from the age of 7-8 to take part in our archery training on the weekends. You can inquire about the current training dates in our shop.",
		subtitle_six: "Teaching",
		text_six: "We are happy to help everybody who wishes to start archery. Learn the basics with us! We’ll give you everything you need!",
		link_text: "More info"
	},
	about:{
		section_one: "Like for most people, archery was something that began in my childhood. Later, when I had my own kids, the bow I used as a child was started to be used by my son. After a while, I got us “real” bows to shoot with, and we started attending competitions. My daughter also joined us and slowly I began making us our own arrows, quivers, belts, hats and boots.",
		section_two: "In October 2006 I opened my own archery shop called Csodaszarvas íjászbarlang in Villányi Street. I’ve always wanted to teach, so I became an accredited archery teacher too. Then we had the opportunity to move to a better location, to the other side of Móricz Zsigmond square, where we could open a shooting range along with the shop. Me and my archer friends founded an archery association called Csodaszarvas Sportegyesület. With the new shooting range, everybody was able to practice now, whether it was raining outside or not. And let’s not forget that we could finally start teaching important things - like archery - and “re-educate” the children who came in, teaching them to value traditions and our history, without an age limit.",
		section_three: "… When I took over the shop from my father, my goal was to help it develop. Now the shooting range isn’t only open to traditional archers, but also to Olympic archers. Our olympic durafoam targets and the 18-21 metres long shooting ranges make the shooting suitable for them as well. Anyone who needs to prepare for competitions has a place here. Our targets are moveable. ",
		section_four: "We also believe that craftman entrepreneurs’ bows are being made with more care and skill than manufactured ones, so you can only find craftsman's work in our shop. This is also how we try to support these small businesses. Our company also began to sell hand-made products, bows and arrows that are our own brand, mostly made by my father. We’ve put more than 15 years of experience into our bow’s design and implementation. Our archery association now has an Olympic-archery group too. Many traditional archers decided to try themselves out due to our new, adequate shooting range, which gives an opportunity to train during the season. In the future we’re planning on opening an outdoor shooting range too.",
		signature_one: "- Péter Cselőtei",
		signature_two: "- Tamás Cselőtei",
	},
	field:{
		intro_zero: "The archery range should be reserved in advance via phonecall (if someone just “drops by” we cannot ensure that there will be a shooting range available.) If you’d like to come with a bigger group or company, there is a possibility to reserve the whole archery range (6 standing places) as well!",
		intro_first: "Our field has three 18 and three 21 metres long. Our olympic durafoam targets and the 18-21 metres long shooting ranges make the shooting suitable for them as well. Anyone who needs to prepare for competitions has a place here. Our targets are moveable.",
		intro_second: "In case you need proper instructions in length, kindly ask for a date beforehand! (We will set fix dates for teaching groups later.)",
		li_0: "The fee for one archery range/person: 3.000 Ft",
		li_1: "The rental for the equipment (arrows, bow, protection) for one hour is: 2.000 Ft (Only if it was pre-arranged!)",
		li_2: "The fee for the whole archery range (6 places)/hour (during opening hours): 25.000 Ft",
		li_3: "The fee for the whole archery range (6 places)/hour (after opening hours): 19.500 Ft",
		li_4: "Monthly ticket: 30.000 Ft - It includes only the range rental (1 place) for 12 occasions, with a 90-day expiration date.",
		li_5: "Monthly ticket with equipment: 45.000 Ft.- It includes the range rental (1 place) and the equipment rental (bow, arrows, protectors) for 12 occasions, with a 90-day expiration date.",
		li_6: "The teaching of the basics (how to shoot etc) is free!",
		intro_third: "In case you have any further questions, please",
		link: "contact us.",
		last: "We’re looking forward to seeing everyone who’s interested in trying out archery! Book your spot!",
	},
	association:{
		intro_first: "Our archery association was founded in 2009 with 15 members. Our goals included promoting all activities that was in connection with archery, for example the history and publicity of “archery war games” and shooting competitions, the pursuit of archery as a free-time and sport-level activity as well as the development of archery, the sport itself.",
		intro_second: "We hold weekly trainings for the members on our own archery range and a coach trains the members’ children separately on the weekends in order to ensure proper “reinforcement” for our association.",
		intro_third: "We wanted to provide services to members that facilitate and encourage participation in competitions, demonstrations, and events. Currently we have over 30 active members. Among our members we not only have representatives of traditional archery, but also representatives of other branches of archery (compound, hunter, Olympic-archery, etc.). ",
		intro_fourth: "We actively and regularly participate in historical, 3D, pleasure and long-range shooting competitions. In order to promote archery we consistently attend schools, sporting events and village days where everyone can try themselves out in this fascinating sport.",
	},
	news: {
		title: "Our latest news",
		read_more: "Read more",
		back: "Back to the other article"
	},
	contact: {
		info: 'Informations',
		subtext: 'Please only call us during the opening hours!',
		address: 'Bp. 1117. Siroki Street 2',
		info_text: 'If you come by car, we recommend you park in Siroki street, or if there’s no space there, you can try out Allee Shopping Mall at the end of the street. ( 450 HUF / hour )',
		open: 'Opening hours',
		mon: 'Monday: Closed',
		tue: 'Tuesday: 13:00 to 18:00',
		wed: 'Wednesday: 13:00 to 18:00',
		thu: 'Thursday: 13:00 to 18:00',
		fri: 'Friday: 13:00 to 18:00',
		sat: 'Saturday: 10:00 to 14:00',
		sun: 'Sunday: Closed',
	},
	footer: {
		reserved: 'All rights reserved.',
	},
	product:{
		color: "Color: "
	},
	booking: {
		title: "Booking",
		text: 'Thank you for your booking!',
		subtext: 'If the date is not good for you, you can cancel it within 2 days.'
	}
  },
  hu: {
  	navbar: {
  		brand_name: "Csodaszarvas Íjászbarlang",
  		about: "Rólunk",
		home: "Főoldal",
		field: "Íjászpálya",
		club: "Egyesület",
		contact: "Kapcsolat",
		news: "Hírek",
		products: "Termékeink",
		bows: "Íjak",
		arrows: "Nyílvesszők",
		quivers: "Tegezek",
		targets: "Vesszőfogók",
		protective: "Védőfelszerelések",
		other: "Egyebek",
		booking: "Pályafoglalás",
	},
	not_found:{
		title: "404",
		text: "Ez az oldal nem található."
	},
	main:{
		title: "Csodaszarvas Íjászbarlang",
		intro: "Buda szívében az egyetlen fedett íjászpálya várja 6 lőállással az érdeklődőket, akik kíváncsiak ennek a sportágnak a kihívásaira. Pályánkon lehetőség van megtanulni az alapokat gyakorlott íjászok által. Haladó íjászoknak lehetőségük van a pálya íjászatban a 18 méteres lőtáv gyakorlására.",
		intro_second: "Legyen szó bármilyen íj típusról, várjuk az érdeklődőket és a sportolni vágyókat. Külön rendezvények lebonyolítására is lehetőséget biztosítunk az egész pálya kibérlése során gyerekeknek és felnőtteknek egyaránt. Mindezt a Móricz Zsigmond körtér-től 3 perc sétára.",
	},
	what_we_do:{
		title: "Mivel foglalkozunk?",
		subtitle_first: "Pályabérlés",
		text_first: "Pályánkon három 18 méteres és két 21 méteres pálya várja telefonos egyeztetés után a jelentkezőket.",
		subtitle_sec: "Csapatépítés",
		text_second: "Pályánkon lehetőség van születésnapok illetve bármilyen körű rendezvények lebonyolítására.",
		subtitle_third: "Oktatás",
		text_third: "Boltunkban bárkinek szívesen segítünk hogy az íjászathoz az alap technikai felkészültsége meglegyen.",
		subtitle_fourth: "Egyesületi élet",
		text_fourth: "Egyesületünk várja az újabb tagok jelentkezését, akik érdekel a versenyzés vagy csak maga a sport.",
		subtitle_fifth: "Gyerek edzés",
		text_fifth: "7-8 éves kortól várjuk a gyerekek jelentkezését a hétvégén megtartott edzésekre. Aktuális időpontokról a boltban kell érdeklődni.",
		subtitle_six: "Íj/vessző készítés",
		text_six: "Boltunk vállalja egyedi tradicionális és vadászreflex íjak valamint verseny vesszők gyártását előzetes egyeztetés alapján.",
		link_text: "További infó"
	},
	about:{
		section_one: "Mint a legtöbb embernél, gyerekkori indíttatás volt az íjászkodás. A gyerekkoromból megmaradt íjat a fiam használni kezdte, majd megvettük „igazi” íjainkat és elkezdtünk versenyekre járni. Bekapcsolódott a lányom is és elkészültek a saját nyilak, tegezek, övek, süvegek, csizmák.",
		section_two: "2006 októberében megnyílt a Csodaszarvas Íjászbarlang a Villányi úton. Mindig is tanítani akartam, így tanári hivatásom mellett elvégeztem az íjász oktatói tanfolyamot is. Jött a lehetőség hogy a Móricz Zsigmond körtér másik oldalán kiadóvá vált egy olyan helyiség ahol ki tudtunk alakítani egy boltot és egy íjászpályát is egyben! Megalakítottuk barátaimmal a Csodaszarvas Sportegyesületet. Az íjászat kedvelői szélben, hóban, esőben is tudták gyakorolni kedvenc sportjukat. Nem beszélve arról, hogy elindulhatott az igazi tanítás, az utánpótlás nevelés, és mind  	enki jöhet korhatár nélkül íjászatot tanulni!",
		section_three: "...Amikor 2017-ben átvettem apámtól a boltot célom volt hogy továbbfejlesszem. A pálya már nem csak a tradicionális íjászok előtt áll nyitva, hanem az olimpiai íjászokat is fogadja. Az új akár olimpiai durafoam-os céltáblák, a 18 és a 21 méter is teljesen alkalmas versenyfelkészülésre. Céltábláink mozgathatók.",
		section_four: "Hiszünk abban, hogy a kézműves kisvállalkozók íjai több figyelemmel és jobb odafigyelessel készülnek, ezért csak őket forgalmazzuk. Ezzel támogatva a hazai kisvállalkozókat. Cégünk belekezdett a saját márkás íjak forgalmazásába is. Több mint 15 évnyi tapasztalatot gyúrtunk bele íjaink felépítésébe és kivitelezésébe. Egyesületünk már olimpiai szakággal is rendelkezik, mivel több tradicionális íjászunk is élt a lehetőséggel, amit az új pálya biztosít a terem szezon idején a felkészüléshez. Jövőben tervezzük, egy kültéri pálya létrehozását is.",
		signature_one: "- Cselőtei Péter",
		signature_two: "- Cselőtei Tamás",
	},
	field:{
		intro_zero: "Az íjászpályát előzetes telefonon történő bejelentkezés alapján lehet lefoglalni. (Ha valaki csak úgy ‘beugrik’, nem biztos, hogy lesz szabad pálya.) Lehetőség van csoportok, társaságok számára az egész pálya kibérlésére is!",
		intro_first: "A pálya három 18 méteres és három 21 méteres lőállással rendelkezik. Az új akár olimpiai durafoam-os céltáblák, a 18 és a 21 méter is teljesen alkalmas versenyfelkészülésre. Céltábláink áthelyezhetőek.",
		intro_second: "Amennyiben igény mutatkozik oktatásra, úgy azok időpontját telefonon kell előzetesen egyeztetni! (Később fix időopontokat alakítunk ki csoportos oktatásra.)",
		li_0: "Egy lőállás díja óránként: 3.000 Ft",
		li_1: "Felszerelés (íj, nyilak, védőfelszerelés) bérleti díja egy órára 2.000 Ft (Csak az előzetes megbeszélés után kialakított időpontokban.)",
		li_2: "Az egész terem bérleti díja óránként (nyitvatartási időben): 25.000 Ft",
		li_3: "Az egész terem bérleti díja óránként (nyitvatartási időn kívül): 19.500 Ft",
		li_4: "Bérlet: 30.000 Ft - Kizárólag a pályabérlést tartalmazza, 12 alkalomra szól, 90 napos lejárati idővel.",
		li_5: "Bérlet felszereléssel: 45.000 Ft.- Tartalmazza mind a pálya mind a felszerelés bérlését, 12 alkalomra szól, 90 napos lejárati idővel",
		li_6: "Az oktatás, alapok tisztázása ingyenes!",
		intro_third: "Amennyiben további kérdése merül fel, kérem keressen meg az",
		link: "elérhetőségeinken.",
		last: "Szeretettel várunk minden érdeklődőt a hét minden napján!",
	},
	association:{
		intro_first: "Egyesületünk 2009-ben alakult 15 fő részvételével. Céljaink között szerepelt minden olyan tevékenység elősegítése, ami az íjászat és a hadijátékok történetéhez, nyilvánosságához, szabadidős és sportszinten való űzéséhez és a sportág fejlesztéséhez kapcsolódik.",
		intro_second: "Íjászpályánkon heti rendszerességgel tartunk edzéseket egyesületi tagjaink részére, valamint minden hétvégén külön edző foglalkozik a gyerekekkel az utánpótlás nevelés érdekében.",
		intro_third: "Olyan szolgáltatásokat szerettünk volna nyújtani a tagok számára, amelyek elősegítik és ösztönzik a versenyeken,bemutatókon, rendezvényeken való részvételt. Jelen pillanatban több mint 30 aktív tagunk van. Tagjaink között nem csak a tradicionális, hanem az íjászat minden ágának (hagyományőrző-, csigás-, vadász-, olimpiai-íjászat, stb.) képviselői meg találhatóak.",
		intro_fourth: "Rendszeresen részt veszünk történelmi, 3d, örömíjász és táv-céllövő versenyeken. Az íjászat népszerűsítésének érdekében rendszeresen megjelenünk iskolákban, sportrendezvényeken, falunapokon ahol mindenki kipróbálhatja magát ebben a sportban.",
	},
	news: {
		title: "Híreink",
		read_more: 'Olvass tovább',
		back: "Vissza a többi cikkhez"
	},
	contact: {
		info: 'Információk',
		subtext: 'Kérjük, hogy csak nyitvatartási időben keressenek minket telefonon!',
		address: 'Bp. 1117. Siroki utca 2',
		info_text: 'A Siroki utcában és az utca végén található Allee bevásárlóközpont parkolójában van lehetőség a parkolásra. (óránként 450 FT)',
		open: 'Nyitvatartás',
		mon: 'Hétfő: Zárva',
		tue: 'Kedd: 13:00-től 18:00-ig',
		wed: 'Szerda: 13:00-től 18:00-ig',
		thu: 'Csütörtök: 13:00-től 18:00-ig',
		fri: 'Péntek: 13:00-től 18:00-ig',
		sat: 'Szombat: 10:00-től 14:00-ig',
		sun: 'Vasárnap: Zárva',
	},
	footer: {
		reserved: 'Minden jog fenntartva.',
	},
	product:{
		color: "Szín: "
	},
	booking: {
		title: "Pályafoglalás",
		read_more: 'Új',
		text: 'Köszönjük foglalásodat! Várunk szeretettel!',
		subtext: 'Kérjük ne feledd, hogy váltócipő használata kötelező! Illetve, ha mégsem jó számodra az időpont 2 napon belül letudod mondani. '
	},
  }
};


// WEBPACK FOOTER //
// ./src/i18n.js